
//poi信息(通过poi)
export function _getPoiInfo($map,poiArray) {
    if(!poiArray)return;

    let $query = (type,value,callback)=>{

        $VAR.brtmapSearch.query({
            type:type,  //'poiid'
            value:value
        }, function (result) {
            callback && callback(result);
        })
    };

    for(let i=0;i< poiArray.length;i++){

        let POIID = poiArray[i].POI_ID;

        $query('poiid',POIID,result=>{

            result = result.filter((item,index,self)=>{
                return item.POI_ID == POIID
            });

            if(result[0]){

                result[0].LngLat = $VAR.map.coordsToLnglat(result[0].LABEL_X,result[0].LABEL_X);

                //拼接号馆
                if(result[0].REGION && result[0].NAME &&  result[0].NAME.indexOf(result[0].REGION) === -1){
                    result[0].NAME =  result[0].REGION  +  result[0].NAME;
                }
            }

            poiArray[i].poi = result[0];

            /*
            if(result.length && result[0].NAME.indexOf('号馆') == -1 && result[0].ZONE_ID){

                $query('poiid',result[0].ZONE_ID,res=>{

                    if(res.length && res[0].NAME.indexOf('号馆')> -1){result[0].NAME = res[0].NAME + result[0].NAME;}
                    result[0].LngLat = $VAR.map.coordsToLnglat(result[0].LABEL_X,result[0].LABEL_X);
                    poiArray[i].poi = result[0];

                })

            }else{

                result[0].LngLat = $VAR.map.coordsToLnglat(result[0].LABEL_X,result[0].LABEL_X);
                poiArray[i].poi = result[0];
            }
          */

        })


    }

    return poiArray;
}


//活动poi合并
export function _activityPoiExtend(poiArray, activityData) {
    // let activityData = this.$store.state.ACTIVITY_DATA;
    if(!poiArray)return;
    activityData = activityData.concat();
    for(let i = 0; i < activityData.length; i++) {

        let activity = activityData[i];

        for(let k = 0; k < poiArray.length; k++) {

            let poi = poiArray[k];

            if(poi.POI_ID === activity.POI_ID) {
                poi.activity = activity;
            }
        }
    }
    return poiArray;
}

//主题活动poi查询(存在一对多关系)
export function _themeActivityPoiExtend(poiArray, activityData) {

    if(!poiArray)return;

    poiArray = poiArray.concat();

    //统一清空防止重复
    for(let k = 0; k < poiArray.length; k++) {
        let poi = poiArray[k];
        poi.theme_activity=[];
    }

    //切断联系
    activityData = activityData.concat();

    //寻找相匹配的主题活动
    for(let i = 0; i < activityData.length; i++) {

        let activity = activityData[i];

        for(var j=0;j<activity.store.length;j++){

            let $store = activity.store[j];

            for(let k = 0; k < poiArray.length; k++) {

                let poi = poiArray[k];

                if($store.poi && poi.POI_ID === $store.poi.POI_ID) {
                    poi.theme_activity.push(activity);
                }
            }

        }
    }

    return poiArray;
}

//poi详情合并
export function _detailPoiExtend(poiArray, detailData) {

    if(!poiArray)return;
    // let detailData = this.$store.state.POI_DETAIL_DATA;

    detailData = detailData.concat();

    for(let i = 0; i < detailData.length; i++) {

        let detail = detailData[i];

        for(let k = 0; k < poiArray.length; k++) {
            let poi = poiArray[k];

            if(poi.POI_ID === detail.POI_ID) {
                poi.detail = detail;
            }
        }
    }
    return poiArray;
}



//类型图标
export  function CATEGORY_ICONExtend(poiArray) {
    if(!poiArray)return;

    poiArray = poiArray.concat();

    for(let i = 0; i < poiArray.length; i++) {
        if(poiArray[i].POI_ID == 'location'){
            poiArray[i]['CATEGORY_ICON'] = './images/selecte_null.png';
        }else{
            poiArray[i]['CATEGORY_ICON'] = 'https://files.brtbeacon.net/BRTMap/images/'+poiArray[i].CATEGORY_ID+'_normal.png';
        }


    }
    return poiArray;
}
